// extracted by mini-css-extract-plugin
export var button = "_90-4";
export var hasDarkBackground = "_90-7";
export var hasLightBackground = "_90-6";
export var iconWrapper = "_90-0";
export var large = "_90-2";
export var medium = "_90-1";
export var small = "_90-5";
export var xsmall = "_90-3";